export const paths = {
  login: '/login',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  home: '/',
  rewards: '/rewards',
  recycle: '/recycle',
  history: '/history',
  reviews: '/reviews',
  appVersions: '/app-versions',
  adminBinGuidelines: '/admin/bin-guidelines',
  adminMaterials: '/admin/materials',
  adminOrgAdmins: '/admin/org-admins',
  adminAnnotatorAccess: '/admin/annotator-access',
  profile: '/profile',
};

export default paths;
